import { useEffect } from 'react';

const SEO = ({ title, description, keywords, ogImage }) => {
  useEffect(() => {
    // Update Title
    const baseTitle = "Study Centro";
    document.title = title ? `${title} | ${baseTitle}` : baseTitle;

    // Update Meta Description
    const updateMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`) || 
               document.querySelector(`meta[property="${name}"]`);
      
      if (!el) {
        el = document.createElement('meta');
        if (name.startsWith('og:')) {
          el.setAttribute('property', name);
        } else {
          el.setAttribute('name', name);
        }
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    updateMeta('description', description || "Study smarter with Study Centro - Your ultimate exam preparation platform.");
    updateMeta('keywords', keywords || "study, exams, preparation, documents, mcq, tests");
    updateMeta('og:title', title || baseTitle);
    updateMeta('og:description', description);
    if (ogImage) updateMeta('og:image', ogImage);

    // Clean up or reset can be added here if needed
  }, [title, description, keywords, ogImage]);

  return null; // This component doesn't render anything UI-wise
};

export default SEO;
